/**
 * @generated SignedSource<<12f1a435e3f086f0c815d736c71b5faa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelPaginationQuery$variables = {
  after?: string | null;
  first?: number | null;
  proposalId: string;
};
export type FeedbackCastPanelPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelFeedbackFragment">;
};
export type FeedbackCastPanelPaginationQuery = {
  response: FeedbackCastPanelPaginationQuery$data;
  variables: FeedbackCastPanelPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "proposalId",
    "variableName": "proposalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCastPanelPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "FeedbackCastPanelFeedbackFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCastPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProposalFeedbackConnection",
        "kind": "LinkedField",
        "name": "proposalFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProposalFeedbackEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProposalFeedback",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "kind": "LinkedField",
                    "name": "sender",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResolvedName",
                            "kind": "LinkedField",
                            "name": "resolvedName",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotingPower",
                    "kind": "LinkedField",
                    "name": "votes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TokenAmount",
                        "kind": "LinkedField",
                        "name": "amount",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OnChainProposal",
                    "kind": "LinkedField",
                    "name": "proposal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProposalUpdate",
                        "kind": "LinkedField",
                        "name": "updateHistory",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "approximateTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportDetailed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "proposalId"
        ],
        "handle": "connection",
        "key": "FeedbackCastPanelFragment_proposalFeedback",
        "kind": "LinkedHandle",
        "name": "proposalFeedback"
      }
    ]
  },
  "params": {
    "cacheID": "99171be473b96f245b61f1b27cc7e51d",
    "id": null,
    "metadata": {},
    "name": "FeedbackCastPanelPaginationQuery",
    "operationKind": "query",
    "text": "query FeedbackCastPanelPaginationQuery(\n  $after: String\n  $first: Int = 30\n  $proposalId: ID!\n) {\n  ...FeedbackCastPanelFeedbackFragment_rFcex\n}\n\nfragment FeedbackCastPanelFeedbackFragment_rFcex on Query {\n  proposalFeedback(proposalId: $proposalId, first: $first, after: $after) {\n    edges {\n      node {\n        sender {\n          address {\n            address\n          }\n          id\n        }\n        ...FeedbackRowFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FeedbackRowFragment on ProposalFeedback {\n  id\n  reason\n  votes {\n    amount {\n      amount\n    }\n  }\n  proposal {\n    updateHistory {\n      timestamp\n      id\n    }\n    id\n  }\n  sender {\n    address {\n      address\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    id\n  }\n  approximateTimestamp\n  ...FeedbackRowTextFragment\n}\n\nfragment FeedbackRowTextFragment on ProposalFeedback {\n  supportDetailed\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  name\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n"
  }
};
})();

(node as any).hash = "1a330953d55292759388daa6db9222a8";

export default node;
